import { __assign, __awaiter, __generator } from "tslib";
import { createActionMap, getDefaultBrowserHistory, } from 'retil-history';
import { fuse, getSnapshotPromise, subscribe, } from 'retil-source';
import { createMemo } from 'retil-support';
export function createRequestService(options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var _a = options.basename, basename = _a === void 0 ? '' : _a, _b = options.historyService, baseService = _b === void 0 ? getDefaultBrowserHistory() : _b, extend = options.extend;
    var baseSource = baseService[0], baseController = baseService[1];
    var planningActions = createActionMap();
    var plannedActions = new Map();
    var planUnsubscribes = new Set();
    var requestMemo = createMemo();
    var source = fuse(function (use) {
        var historyRequest = use(baseSource);
        var plannedRequest = historyRequest.planId && plannedActions.get(historyRequest.planId);
        // Clear our plans, as any change from now on should result in a new
        // request.
        plannedActions.clear();
        planningActions.clear();
        planUnsubscribes.forEach(function (unsubscribe) { return unsubscribe(); });
        planUnsubscribes.clear();
        // Get the extension even if we have a planned request, as we want to make
        // sure that any changes to sources that the extension uses will trigger
        // another execution of the fusor function.
        var extension = (extend && extend(historyRequest, use));
        return requestMemo(function () {
            return plannedRequest || __assign(__assign(__assign({ params: {}, basename: basename }, historyRequest), extension), { planId: undefined });
        }, [historyRequest, extension]);
    });
    var createPlan = function (action) { return __awaiter(_this, void 0, void 0, function () {
        var plannedHistoryRequest, extensionSource, extension, plannedRequest, unsubscribe;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, baseController.plan(action)];
                case 1:
                    plannedHistoryRequest = _a.sent();
                    if (!extend) {
                        return [2 /*return*/, __assign({ basename: basename, params: {} }, plannedHistoryRequest)];
                    }
                    extensionSource = fuse(function (use) { return extend(plannedHistoryRequest, use); });
                    return [4 /*yield*/, getSnapshotPromise(extensionSource)];
                case 2:
                    extension = _a.sent();
                    plannedRequest = __assign(__assign({ basename: basename, params: {} }, plannedHistoryRequest), extension);
                    plannedActions.set(plannedRequest.planId, plannedRequest);
                    unsubscribe = subscribe(extensionSource, function () {
                        plannedActions.delete(plannedRequest.planId);
                        planningActions.delete(action);
                        planUnsubscribes.delete(unsubscribe);
                        unsubscribe();
                    });
                    planUnsubscribes.add(unsubscribe);
                    return [2 /*return*/, plannedRequest];
            }
        });
    }); };
    var controller = {
        block: baseController.block,
        navigate: function (action) { return __awaiter(_this, void 0, void 0, function () {
            var currentlyPlanning, hasChanged_1, unsubscribe;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentlyPlanning = planningActions.get(action);
                        if (!(currentlyPlanning && !currentlyPlanning.done)) return [3 /*break*/, 2];
                        hasChanged_1 = false;
                        unsubscribe = subscribe(baseSource, function () {
                            hasChanged_1 = true;
                        });
                        return [4 /*yield*/, currentlyPlanning];
                    case 1:
                        _a.sent();
                        unsubscribe();
                        if (hasChanged_1) {
                            return [2 /*return*/, false];
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, baseController.navigate(action)];
                }
            });
        }); },
        plan: function (action) {
            var planningRequest = planningActions.get(action);
            if (planningRequest) {
                return planningRequest.promise;
            }
            var promise = createPlan(action);
            var cache = { promise: promise, done: false };
            planningActions.set(action, cache);
            promise.then(function () {
                cache.done = true;
            });
            return promise;
        },
    };
    return [source, controller];
}
